import { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { useTheme } from '../contexts/ThemeContext.jsx'
import { useLanguage } from '../contexts/LanguageContext.jsx'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Features from '../components/Features'
import Offers from '../components/Offers'
import Gallery from '../components/Gallery'
import Contact from '../components/Contact'
import Footer from '../components/Footer'
import InstallPrompt from '../components/InstallPrompt.jsx'

function Home() {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isStandalone, setIsStandalone] = useState(false)

  const { theme } = useTheme()
  const { language } = useLanguage()

  useEffect(() => {
    setIsLoaded(true)

    // Check if running in standalone mode (installed PWA)
    const checkStandalone = () => {
      const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches ||
                               window.navigator.standalone === true
      setIsStandalone(isStandaloneMode)
    }

    checkStandalone()

    // Listen for display mode changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)')
    const handleChange = (e) => {
      setIsStandalone(e.matches)
    }

    mediaQuery.addEventListener('change', handleChange)

    return () => {
      mediaQuery.removeEventListener('change', handleChange)
    }
  }, [])

  // Show loading while checking
  if (!isLoaded) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--bg-primary)' }}>
        <motion.div
          className="w-16 h-16 border-4 border-yellow-400 border-t-transparent rounded-full"
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
        />
      </div>
    )
  }

  // Not installed - show install prompt (for all platforms including Windows)
  if (!isStandalone) {
    return <InstallPrompt />
  }

  // Installed - show full website
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Offers />
        <Gallery />
        <Contact />
      </main>
      <Footer />
    </motion.div>
  )
}

export default Home
